"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cislago": {
    "9d726614": [{
      "hkey": "41d00974",
      "slug": "cislago",
      "name": "Cislago",
      "primary": true,
      "skipSearch": false
    }],
    "casina-massina": [{
      "hkey": "41d00974",
      "slug": "cislago",
      "name": "Cislago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7a4bee47": [{
      "hkey": "41d00974",
      "slug": "cislago",
      "name": "Cislago",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-inziata": [{
      "hkey": "41d00974",
      "slug": "cislago",
      "name": "Cislago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;